module.exports = __webpack_public_path__ + "static/media/truck9b.fdd915c7.svg";